module.exports = __webpack_public_path__ + "img/03_slip_rubber.aeef81f4.png";